import { useMemo } from 'react'
import { KeyValuePairs, Checkbox } from 'components/ideal-core-ui'
import { Container, Row, Col } from 'reactstrap'
import { APP_CONSTANTS } from 'utils/constants'
import s from './GeneralInfo.scss'
import { timezoneDate } from 'utils/helpers'

const getPairs = ({
  address,
  address2,
  street2,
  city,
  state,
  zipcode,
  phone,
  additionalPhone,
  fax,
  website,
  email,
  emailDomain,
  types,
  size,
  country,
  preQualified,
  preQualifiedExpDate,
  noBid,
  noBidReason,
  noBidReasonDescription,
  description,
  segment,
  parentCompany
}) => {
  const pairs = []

  description &&
    pairs.push({
      key: 'Description:',
      value: <span>{description}</span>
    })
  address &&
    pairs.push({
      key: 'Address:',
      value: <span>{address}</span>
    })
  address2 &&
    pairs.push({
      key: 'Street 1:',
      value: <span>{address2}</span>
    })
  street2 &&
    pairs.push({
      key: 'Street 2:',
      value: <span>{street2}</span>
    })
  city &&
    pairs.push({
      key: 'City:',
      value: <span>{city}</span>
    })
  state &&
    pairs.push({
      key: 'State/Province/Region:',
      value: <span>{state}</span>
    })
  zipcode &&
    pairs.push({
      key: 'Zip/Postal Code:',
      value: <span>{zipcode}</span>
    })
  country &&
    pairs.push({
      key: 'Country:',
      value: <span>{country}</span>
    })
  phone &&
    pairs.push({
      key: 'Phone:',
      value: <span>{phone}</span>
    })
  additionalPhone &&
    pairs.push({
      key: 'Additional Phone:',
      value: <span>{additionalPhone}</span>
    })
  fax &&
    pairs.push({
      key: 'Fax:',
      value: <span>{fax}</span>
    })
  website &&
    pairs.push({
      key: 'Website:',
      value: (
        <span>
          <a href={website} target="_blank" rel="noreferrer">
            {website}
          </a>
        </span>
      )
    })
  email &&
    pairs.push({
      key: 'Email:',
      value: <span>{email}</span>
    })
  emailDomain &&
    pairs.push({
      key: 'Email Domain:',
      value: <span>{emailDomain}</span>
    })
  !!types?.length &&
    pairs.push({
      key: 'Company Types:',
      value: <span>{types.map(type => type.name).join(', ')}</span>
    })
  segment &&
    pairs.push({
      key: 'Market Segment:',
      value: <span>{segment.name}</span>
    })
  size &&
    pairs.push({
      key: 'Company Level:',
      value: <span>{APP_CONSTANTS.CompanySize[size]}</span>
    })
  parentCompany &&
    pairs.push({
      key: 'Parent Company:',
      value: <span>{parentCompany.label}</span>
    })
  preQualified &&
    pairs.push({
      key: 'Pre-Qualified:',
      value: <span>{preQualified ? 'Yes' : 'No'}</span>
    })
  preQualified &&
    preQualifiedExpDate &&
    pairs.push({
      key: 'Pre-Qualification Exp Date:',
      value: <span>{timezoneDate(preQualifiedExpDate)}</span>
    })

  if (noBid) {
    pairs.push({
      key: 'Do not bid:',
      value: <Checkbox isChecked={noBid} name="noBid" disabled />
    })
    if (noBidReason) {
      pairs.push({
        key: 'Reason for not bidding:',
        value: (
          <span>
            {noBidReason.name === 'Other' && noBidReasonDescription
              ? noBidReasonDescription
              : noBidReason.name}
          </span>
        )
      })
    }
  }

  return pairs
}

const GeneralInfo = ({
  address,
  address2,
  street2,
  city,
  state,
  country,
  zipcode,
  phone,
  additionalPhone,
  fax,
  website,
  email,
  emailDomain,
  types,
  size,
  preQualified,
  preQualifiedExpDate,
  noBid,
  noBidReason,
  noBidReasonDescription,
  description,
  segment,
  parentCompany
}) => {
  const pairs1 = useMemo(
    () =>
      getPairs({
        address,
        address2,
        street2,
        city,
        state,
        country,
        zipcode,
        phone,
        additionalPhone,
        fax,
        description
      }),
    [
      address,
      address2,
      street2,
      city,
      state,
      country,
      zipcode,
      phone,
      additionalPhone,
      fax,
      description
    ]
  )

  const pairs2 = useMemo(
    () =>
      getPairs({
        website,
        email,
        emailDomain,
        types,
        segment,
        size,
        parentCompany,
        preQualified,
        preQualifiedExpDate,
        noBid,
        noBidReason,
        noBidReasonDescription
      }),
    [
      website,
      email,
      emailDomain,
      types,
      segment,
      size,
      parentCompany,
      preQualified,
      preQualifiedExpDate,
      noBid,
      noBidReason,
      noBidReasonDescription
    ]
  )

  return (
    <Container>
      <Row>
        <Col lg="6">
          <section className={s.generalInfoContainer}>
            <KeyValuePairs pairs={pairs1} />
          </section>
        </Col>
        <Col lg="6">
          <section className={s.generalInfoContainer}>
            <KeyValuePairs pairs={pairs2} />
          </section>
        </Col>
      </Row>
    </Container>
  )
}

export default GeneralInfo
